import axios from 'axios'
import { Toast } from 'vant';
import Vue from 'vue'
import { Dialog } from 'vant';

// create an axios instance
const service = axios.create({
  baseURL: process.env.ROOT_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})


const login = () => {
  let service = `${window.location.origin}/login?service=${window.location.href}`

  let callback =
    `${process.env.ROOT_API}/weixin/authorize?service=${Base64.encode(service)}`

  window.location.href = callback
}

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get('Access-Token')
    console.log('------异常响应------', token)
    console.log('------异常响应------', error.response.status)
    switch (data.status) {
      case 403:

        Toast.fail('拒绝访问');

        break
      case 500:
        console.log('------error.response------', error.response)
        // update-begin- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        let type = error.response.request.responseType
        if (type === 'blob') {
          blobToJson(data)
          break
        }
        // update-end- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if (data.message.includes('Token失效')) {


          login()

          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:

        Toast.fail('很抱歉，资源未找到');
        break
      case 504:
        Toast.fail('网络超时');
        break
      case 401:
        Toast.fail('未授权，请重新登录');

        break
      default:
        Toast.fail(data.message);
        break
    }
  }
  return Promise.reject(error)
}


// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    const token = Vue.ls.get('Access-Token')
    if (token) {
      config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    console.log(error)
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    let data = response.data

    if (data.success) {
      return response.data
    } else {
      err({ response })
    }

  }, err
)

export default service



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 